module.exports = __webpack_public_path__ + "01ea978f/img/print-icon.d8dbbca5.svg";